import { Block } from 'components/Block'
import { SImageWrapper, SText, STextWrapper, STitle, SWrapper } from './GuidebookHero.styled'
import { ElementType, ReactNode } from 'react'

export function GuidebookHero(props: {
  title: ReactNode
  description: string
  action: ReactNode
  image: ReactNode
  titleAs: ElementType
}) {
  return (
    <Block>
      <SWrapper>
        <STextWrapper>
          <STitle as={props.titleAs} variant={['h4', 'h2']}>
            {props.title}
          </STitle>

          <SText>{props.description}</SText>

          {props.action}
        </STextWrapper>

        <SImageWrapper>{props.image}</SImageWrapper>
      </SWrapper>
    </Block>
  )
}
